import React from 'react';
import { CardContent as MuiCardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

import { POST_CARD_HEIGHT } from './CardMedia';

const StyledCardContent = styled(MuiCardContent, {
  shouldForwardProp: (prop: any) => prop !== 'showPicture',
})(({ theme, showPicture }: any) => ({
  ...(showPicture && { Height: POST_CARD_HEIGHT }),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    width: '100%',
  },
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
  '&> .line-clamp': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box', // supported in all major modern browsers https://caniuse.com/?search=line-clamp
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
}));

function CardContent({ children, ...props }: any) {
  return <StyledCardContent {...props}>{children}</StyledCardContent>;
}

export default CardContent;
